import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { firebaseAuth } from '@/lib/firebase';
import { AppShell } from '@/components/layout/AppShell';

// Auth guard — all routes under /_auth require login
export const Route = createFileRoute('/_auth')({
  beforeLoad: async () => {
    await firebaseAuth.authStateReady();
    if (!firebaseAuth.currentUser) throw redirect({ to: '/login' });
  },
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
